import { useUserStore } from '@/shared/store'
import { TravelDirection } from '@/shared/types/common.types'
import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
import { useRouter, useRoute } from 'vue-router'

export const useFormDataWithRedirect = () => {
  const userStore = useUserStore()
  const router = useRouter()
  const route = useRoute()

  const redirectToContacts = (direction: TravelDirection) => {
    router.push({
      name:
        direction === TravelDirection.OUTBOUND
          ? OutboundFlowRoutes.CONTACTS
          : InboundFlowRoutes.CONTACTS,
      params: { locale: route.params.locale },
    })
  }

  const getFormData = async (
    direction: TravelDirection,
    isFullFields = false,
    isPersonalInfo = false
  ) => {
    try {
      const formData = await userStore.getFormData(direction, isFullFields)
      if (isPersonalInfo) {
        if (!userStore.email || !userStore.phone) {
          redirectToContacts(direction)
          return false
        }
        return true
      }
      if (formData) return true
      redirectToContacts(direction)
      return false
    } catch (error) {
      console.error(error)
      redirectToContacts(direction)
      return false
    }
  }

  return {
    getFormData,
  }
}
